/**
 * @param {HTMLElement} container
 * @returns {{isDirty: () => boolean, reset: () => void, destroy: () => void}}
 */
export const FormDirtyTracker = (container) => {
    let dirty = false;

    const setDirty = (value) => {
        if (value === dirty) {
            return;
        }

        dirty = value;
        container.dispatchEvent(new CustomEvent(dirty ? 'form:dirty' : 'form:clean', {bubbles: true}));
    };

    const markDirty = (event) => {
        if (event.target.closest('[data-ignore-dirty]')) {
            return;
        }

        setDirty(true);
    };

    container.addEventListener('input', markDirty);
    container.addEventListener('change', markDirty);

    return {
        isDirty: () => dirty,
        touch:   () => setDirty(true),
        reset:   () => setDirty(false),
        destroy: () => {
            container.removeEventListener('input', markDirty);
            container.removeEventListener('change', markDirty);
        },
    };
};
